export const listBreadcrumbs = (courseId) => [
  {
    isLink: true,
    color: 'text.secondary',
    label: 'หลักสูตรทั้งหมด',
    link: '/course',
  },
  {
    isLink: true,
    color: 'text.secondary',
    label: 'รายละเอียดหลักสูตร',
    link: `/course/${courseId}`,
  },
  {
    isLink: false,
    color: 'primary',
    label: 'รายละเอียดคลาส',
  },
]
